export const EMPTY_LIST_IMG = "/images/empty-list.png";
export const NO_SEARCH_RESULT_IMG = "/images/no-search-result.png";
